import BiBaseDataItem from '../common/bi-base-item';
import { widgetLoaded } from './platform-actions';

export default class BiPlatformLoadFinishDataItem extends BiBaseDataItem {
  constructor(sessionId, appId, widgetId, isServerSide, metasiteId) {
    super(300, sessionId);

    this.data.actionName = widgetLoaded;
    this.data.appId = appId;
    this.data.widgetId = widgetId;
    this.data.isServerSide = isServerSide;
    this.data.msid = metasiteId;
  }
}
